<template>
  <card>
    <div class="box__title">
      <div>주문확인</div>
    </div>
    <div class="box__content">
      <!-- <div class="progress"></div> -->
      <div class="order-info">
        <div class="info-list" v-for="(pin, idx) in getPins">
          <div
            class="progress"
            :class="{
              progress__valid: !storePinInvalidate.includes(idx),
              progress__focus: stepStatus === 1
            }"
          ></div>
          <div class="pin" @click="moveToSection(`pin-${idx}`, 1)">
            <div class="pin__header">
              <span class="pin__header--title">{{ returnPintitle(idx) }}</span>
              <!-- <span class="pin__header--dateTime">3/9 (목) 14:30 픽업 </span> -->
            </div>
            <div v-if="pin.name || pin.phoneNumber" class="pin__name">
              <span v-if="pin.name">{{ pin.name }}</span
              ><span v-if="pin.phoneNumber">({{ pin.phoneNumber }})</span>
            </div>
            <div class="pin__address">
              {{ fullAddress(pin) }}
            </div>
            <div class="pin__memo" v-if="pin.pinMemo">{{ pin.pinMemo }}</div>
          </div>
        </div>
        <div class="info-list">
          <div
            class="progress"
            :class="{
              progress__valid: getDeliveryOptions.isReserved !== null,
              progress__focus: stepStatus === 2
            }"
          ></div>
          <div @click="moveToSection('delivery-type', 2)" class="pin">
            <div class="pin__header">
              <span class="pin__header--title">배송유형</span>
            </div>
            <div
              v-if="getDeliveryOptions.isReserved !== null"
              class="detail__content detail__content--pickup"
            >
              <div class="detail__content--departure">
                <div
                  v-if="getDeliveryOptions.isReserved && getPins[0].pickupDate"
                  class="detail__content--tag"
                >
                  ・ <orderTag status="reserved" class="tag" />
                  {{ $utcToLocal(getPins[0].pickupDate, "M/D") }}
                  ({{ getPins[0].pickupDate | utcGetDay }})
                  {{ getPins[0].pickupHour }}:{{ getPins[0].pickupMinute }} 픽업
                </div>
                <div v-else>・즉시픽업</div>
              </div>
              <div class="detail__content--Destination">
                <div
                  v-if="getDeliveryOptions.isExpressDelivery !== null"
                  class="detail__content--tag"
                >
                  ・
                  <orderTag
                    v-if="getDeliveryOptions.isExpressDelivery"
                    status="express"
                    class="tag"
                  />
                  <span
                    v-if="!loadingStatus && getDeliveryOptions.isReserved"
                    >{{
                      mixinsEstimatedTime(
                        getDeliveryOptions.isExpressDelivery
                          ? getDeliveryOptions.reserveExpressEstimatedMinutes
                          : getDeliveryOptions.reserveEstimatedMinutes
                      )
                    }}</span
                  >
                  <span
                    v-if="!loadingStatus && !getDeliveryOptions.isReserved"
                    >{{
                      mixinsEstimatedTime(
                        getDeliveryOptions.isExpressDelivery
                          ? getDeliveryOptions.expressEstimatedMinutes
                          : getDeliveryOptions.estimatedMinutes
                      )
                    }}</span
                  >
                  <i
                    v-if="loadingStatus"
                    class="fas fa-circle-notch fa-spin"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-list">
          <div
            class="progress"
            :class="{
              progress__valid: getDeliveryOptions.vehicleCategory !== null,
              progress__focus: stepStatus === 3
            }"
          ></div>
          <div @click="moveToSection('delivery-options', 3)" class="detail">
            <div class="detail__title">배송수단</div>
            <div class="detail__content">
              {{
                filterVehicleCategory(
                  vehicles,
                  getDeliveryOptions.vehicleCategory
                )
              }}
              <span v-if="getDeliveryOptions.vehicleItemCode === 2">
                ({{
                  filterVehicleType(vehicles, getDeliveryOptions.vehicleType)
                }},
                {{
                  filterVehicleOptions(
                    vehicles,
                    getDeliveryOptions.vehicleOption
                  )
                }})
              </span>
            </div>
          </div>
        </div>
        <div class="info-list">
          <div
            class="progress"
            :class="{
              progress__valid: !allItemInvalid && checkFreightOption,
              progress__focus: stepStatus === 4
            }"
          ></div>
          <div
            class="detail"
            @click="moveToSection('delivery-item', 4)"
            v-if="getDeliveryOptions.vehicleItemCode === 1"
          >
            <div class="detail__title">물품상세</div>
            <div class="detail__content">
              {{ mergeItem(getDeliveryOptions.item) }}
              <span v-if="getDeliveryOptions.weight > 0 && stepStatus >= 4"
                >({{ getDeliveryOptions.weight }}kg 이하)</span
              >
            </div>
          </div>
          <div
            class="detail__freight"
            @click="moveToSection('delivery-item', 4)"
            v-if="getDeliveryOptions.vehicleItemCode === 2"
          >
            <div class="detail__title">물품상세</div>
            <div class="detail__content">
              {{ getDeliveryOptions.item["etc"].content }}
            </div>
            <div class="detail__title detail__title--freight">상차옵션</div>
            <div class="detail__content">
              {{ filterPackage(vehicles, getDeliveryOptions.loadingPosition) }}
              <span
                v-if="
                  getDeliveryOptions.loadingMethod !== null &&
                  getDeliveryOptions.loadingPosition !== null
                "
              >
                |
              </span>
              <span>
                {{ filterPackage(vehicles, getDeliveryOptions.loadingMethod) }}
              </span>
            </div>
            <div class="detail__title detail__title--freight">하차옵션</div>
            <div class="detail__content">
              {{
                filterPackage(vehicles, getDeliveryOptions.unloadingPosition)
              }}
              <span
                v-if="
                  getDeliveryOptions.unloadingPosition !== null &&
                  getDeliveryOptions.unloadingMethod !== null
                "
              >
                |
              </span>
              {{ filterPackage(vehicles, getDeliveryOptions.unloadingMethod) }}
            </div>
          </div>
        </div>
        <div class="info-list">
          <div
            class="progress"
            :class="{
              progress__valid: stepStatus >= 5,
              progress__focus: stepStatus === 5
            }"
          ></div>
          <div @click="moveToSection('additional-item', 5)" class="detail">
            <div class="detail__title">요청사항</div>
            <div class="detail__content">
              {{ getDeliveryOptions.clientComment }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="price">
      <div class="price-toggle" @click="isDropdownOpen = !isDropdownOpen">
        <div class="price-toggle__title">결제금액<span>(VAT 포함)</span></div>
        <div class="price-toggle__price">
          <span
            v-if="
              !loadingStatus && getDeliveryOptions.isExpressDelivery !== null
            "
            >{{ getDeliveryOptions.totalOrderFee.toLocaleString() }}</span
          >
          <span v-else-if="getDeliveryOptions.isExpressDelivery === null">
            0
          </span>
          <i v-else class="fas fa-circle-notch fa-spin"></i>원<img
            :class="{ rotate: !isDropdownOpen }"
            src="@/assets/img/order/dropdown.svg"
          />
        </div>
      </div>
      <div class="price-toggle__on" v-if="isDropdownOpen">
        <feeList :deliveryOptions="getDeliveryOptions" />
        <div class="caution">
          <img
            :class="{ caution__img: getDeliveryOptions.vehicleItemCode !== 2 }"
            src="@/assets/img/ic_notice_mypage.svg"
          />
          당일 외 예약접수 시 시간/기상/특수일(토,일,공휴일) 할증요금을
          빼드려요.
        </div>

        <div class="caution" v-show="getDeliveryOptions.vehicleItemCode === 2">
          <img src="@/assets/img/ic_notice_mypage.svg" />
          <div>화물차 배송의 경우 추가요금이 부과될 수 있어요.</div>
        </div>
      </div>
    </div>
    <div class="final">
      <button
        class="final__btn final__cart"
        @click="$emit('placeOrder')"
        :disabled="
          loadingStatus ||
          originTimeInvalid ||
          stepStatus < 5 ||
          getDeliveryOptions.calcUuid === ''
        "
      >
        {{ $route.params.flag === "update" ? "수정하기" : "장바구니 담기" }}
      </button>
      <button
        class="final__btn final__submit"
        @click="$emit('openPayment')"
        :disabled="
          loadingStatus ||
          originTimeInvalid ||
          stepStatus < 5 ||
          getDeliveryOptions.calcUuid === ''
        "
      >
        바로 주문
      </button>
    </div>
  </card>
</template>
<script>
import card from "@/components/common/card.vue";
import mixinFilter from "@/mixins/mixinFilter";
import orderTag from "@/components/common/orderTag.vue";
import tooltip from "@/components/common/tooltip.vue";
import mixinOrder from "@/mixins/mixinOrder";
import mixinOrderValidate from "@/mixins/mixinOrderValidate";
import feeList from "@/components/common/feeList";
import mixinVehicle from "@/mixins/mixinVehicle";
export default {
  mixins: [mixinFilter, mixinOrder, mixinOrderValidate, mixinVehicle],
  components: { card, orderTag, tooltip, feeList },
  props: [
    "stepStatus",
    "loadingStatus",
    "storePinInvalidate",
    "allItemInvalid",
    "originTimeInvalid"
  ],
  data() {
    return {
      isDropdownOpen: false,
      vehicles: null
    };
  },
  async created() {
    const result = await this.$store.dispatch("config/getVehicles");
    this.vehicles = result.vehicle;
  },
  methods: {
    returnPintitle(idx) {
      if (idx === 0) return "출발";
      if (idx === this.getPins.length - 1) return "도착";
      return `경유${idx}`;
    },
    fullAddress(pin) {
      if (pin.jibunAddress) {
        return pin.jibunAddress + " " + pin.detailAddress;
      }
      return "";
    },
    mergeItem(item) {
      const result = [];
      for (const key in item) {
        if (item[key].on) {
          if (key === "etc") {
            if (item[key].content !== null) {
              result.push(`${item[key].content}`);
            }
          } else {
            if (item[key].number > 0)
              result.push(`${this.mixinsItemTitle(key)} ${item[key].number}개`);
          }
        }
      }
      return result.join(", ");
    },
    moveToSection(section, idx) {
      if (this.stepStatus < idx) return;
      if (!section) return;
      const location = document.getElementById(section).offsetTop;
      const headerHeight = document.getElementById("header").offsetHeight;

      window.scrollTo({
        top: location,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
<style src="./layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
